/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UtenteCreateDTO
 */
export interface UtenteCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof UtenteCreateDTO
     */
    userId?: string | null;
}

/**
 * Check if a given object implements the UtenteCreateDTO interface.
 */
export function instanceOfUtenteCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UtenteCreateDTOFromJSON(json: any): UtenteCreateDTO {
    return UtenteCreateDTOFromJSONTyped(json, false);
}

export function UtenteCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtenteCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function UtenteCreateDTOToJSON(value?: UtenteCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
    };
}

